import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import { Button, Modal, message, Result } from "antd";
import { GoogleOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import callAPI from "../../comps/fetch/main";

export default function GoogleButton(props) {
  const [gCode, setGCode] = useState();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (!gCode) return;

    callAPI({
      url: "/google-oauth",
      method: "POST",
      body: { code: gCode },
      loadingState: setLoading,
      dataState: (data) => {
        messageApi.destroy();
        setLoading(false);

        if (data?.code !== 200) {
          setStatus("error");
          messageApi.error("Something went wrong, try again later.");
        } else {
          setStatus("success");
          messageApi.success("Connected.");

          props?.callback()
        }
      },
    });
  }, [gCode]);

  const login = useGoogleLogin({
    flow: 'auth-code',
    scope: "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive.file",
    access_type: "offline",
    prompt: "consent",
    onSuccess: (codeResponse) => {
      messageApi.open({
        type: 'loading',
        content: 'Connecting...',
        duration: 0,
        key: 'google-connect'
      });
      setGCode(codeResponse.code);
      setLoading(true);
    },
    onError: () => {
      setStatus("error");
      messageApi.error("Login failed. Try again.");
    }
  });

  return (
    <div>
      {contextHolder}

      {/* Main Button */}
      {!status && (
        <Button
          type="primary"
          icon={<GoogleOutlined />}
          onClick={() => login()}
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          Connect Google
        </Button>
      )}

      {/* Loading Modal */}
      <Modal open={loading} footer={null} closable={false} centered>
        <div style={{ textAlign: 'center', fontSize: 18 }}>
          <LoadingOutlined spin style={{ fontSize: 40 }} />
          <div style={{ marginTop: 16 }}>Connecting...</div>
        </div>
      </Modal>

      {/* Success Modal */}
      <Modal open={status === "success"} footer={null} closable={false} centered>
        <Result
          status="success"
          title="Google Connected Successfully!"
          subTitle="Your Google Sheets access has been added."
          extra={[
            <Button type="primary" onClick={() => {
    setStatus(null)
    setGCode(null)
    setLoading(false)
  }}>
              Done
            </Button>
          ]}
        />
      </Modal>

      {/* Error Modal */}
      <Modal open={status === "error"} footer={null} closable={false} centered>
        <Result
          status="error"
          title="Failed to Connect"
          subTitle="Google connection could not be completed."
          extra={[
            <Button type="primary" onClick={() => login()}>
              Try Again
            </Button>,
            <Button onClick={() => setStatus(null)}>
              Close
            </Button>
          ]}
        />
      </Modal>
    </div>
  );
}
